<div role="document">
  <header class="modal-header pb-0 px-4 mt-2">
    <h2 class="modal-title">Documentos necessários</h2>
    <a class="header__btn__close" (click)="activeModal.close(true)">
      <span aria-hidden="true">X</span>
    </a>
  </header>
  <main class="modal-body">
    <div class="col-12 mb-1">
      <b>
        Atenção! Antes de prosseguir com o preenchimento do formulário tenha em mãos os seguintes documentos.
      </b>
    </div>
    <section>
      <ul>
        <li>RG, CPF ou CNH do Filho ou Enteado;</li>
      </ul>
    </section>
  </main>
  <footer class="modal-footer">
    <button class="btn btn-primary" (click)="closeModal()">
      Continuar
    </button>
  </footer>
</div>